// import pdfMake from 'pdfmake/build/pdfmake'
// import pdfFonts from 'pdfmake/build/vfs_fonts'

// export function Wallet_Monthly_Transaction_Summary_ExportPDF(
//   formData: any,
//   startDate: string,
//   endDate: string
// ) {
//   // Register the fonts with pdfMake
//   pdfMake.vfs = pdfFonts.pdfMake.vfs

//   const documentDefinition = {
//     pageOrientation: 'landscape' as 'landscape', // Cast the pageOrientation value explicitly
//     pageSize: 'A0' as 'A0',
//     content: [
//       {text: `Exported Data ${startDate} - ${endDate}`, style: 'header'},
//       '\n', // Add a line break
//       {
//         table: {
//           //widths: ['*', '*', '*'], // Adjust column widths as needed
//           body: [
//             [
//               'Wallet ID',
//               'Wallet Account Name',
//               'Wallet Account No',
//               'Wallet Code',
//               'Type',
//               'Wallet Balance',
//               'Deposit Count',
//               'Deposit Amount',
//               'Deposit Commission',
//               'Withdrawal Count',
//               'Withdrawal Amount',
//               'Withdrawal Commission',
//               'B2B Received Count',
//               'B2B Received Amount',
//               'B2B Send Count',
//               'B2B Send Amount',
//               'Settlement Day',
//               'Created Date',
//             ], // Add headers as a separate row
//             ...formData.map((item: any) => [
//               item.walletId,
//               item.walletAccName,
//               item.walletAccNo,
//               item.walletCd,
//               item.type,
//               item.walletBalance,
//               item.depositCount,
//               item.depositAmount,
//               item.depositComm,
//               item.withdrawalCount,
//               item.withdrawalAmount,
//               item.withdrawalComm,
//               item.b2bReceivedCount,
//               item.b2bReceivedAmount,
//               item.b2bSendCount,
//               item.b2bSendAmount,
//               item.settlementDay,
//               item.createdDate,
//             ]),
//           ],
//         },
//         layout: 'lightHorizontalLines', // Add a layout to handle long tables
//       },
//     ],
//     styles: {
//       header: {
//         fontSize: 18,
//         bold: true,
//       },
//     },
//   }

//   const pdfDocGenerator = pdfMake.createPdf(documentDefinition)
//   pdfDocGenerator.download(`Exported Data ${startDate} - ${endDate}.pdf`)
// }

import axios from 'axios'
import {getCurrentDateTime} from '../../components/GetCurrentDatetime'
import {modifyDT} from '../../components/ModifyDT'
import {modifyKeys} from '../../components/ModifyKeys'

const keyMap = {
  walletId: 'Wallet ID',
  walletAccName: 'Wallet Account Name',
  walletAccNo: 'Wallet Account No',
  walletCd: 'Wallet Code',
  type: 'Type',
  walletBalance: 'Wallet Balance',
  depositCount: 'Deposit Count',
  depositAmount: 'Deposit Amount',
  depositComm: 'Deposit Commission',
  withdrawalCount: 'Withdrawal Count',
  withdrawalAmount: 'Withdrawal Amount',
  withdrawalComm: 'Withdrawal Commission',
  b2bReceivedCount: 'B2B Received Count',
  b2bReceivedAmount: 'B2B Received Amount',
  b2bSendCount: 'B2B Send Count',
  b2bSendAmount: 'B2B Send Amount',
  settlementDay: 'Settlement Day',
  createdDate: 'Created Date',
}

// Function to rearrange the dataset based on keyMap
function rearrangeDataset(originalData: any, keyMap: any) {
  return originalData.map((item: any) => {
    const rearrangedItem: any = {}
    for (const key in keyMap) {
      rearrangedItem[keyMap[key]] = item[key]
    }
    return rearrangedItem
  })
}

function escapeCsvValue(value: string): string {
  // If the value contains a comma or line breaks, wrap it in double quotes and escape existing double quotes and line breaks
  if (value.includes(',') || value.includes('\n') || value.includes('\r')) {
    return `"${value.replace(/"/g, '""').replace(/[\n\r]+/g, ' ')}"`
  }
  return value
}

// Remove 'walletId' from each item in the dataset
const removeWalletId = (data: any[]) => data.map(({['Wallet ID']: _, ...rest}) => rest)

function generateFile(formData: any, dateTimeFrom: string, dateTimeTo: string, kepMap: any): void {
  let dataset = rearrangeDataset(formData, keyMap) // Use rearrangeDataset instead of modifyKeys

  // Modify receivedDT
  dataset = modifyDT(dataset, 'Completed DateTime')
  dataset = modifyDT(dataset, 'Deposit DateTime')

  dataset = removeWalletId(dataset) // Remove 'walletId' from each item

  const header = Object.keys(dataset[0]).join(',')
  const rows = dataset.map((transaction: any) =>
    Object.values(transaction)
      .map((value: any) => escapeCsvValue(value.toString()))
      .join(',')
  )

  const csvContent = `${header}\n${rows.join('\n')}`
  const blob = new Blob([csvContent], {type: 'text/csv'})

  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `Wallet-Monthly-Transaction-Summary_${dateTimeFrom}-${dateTimeTo}.csv`
  a.click()

  URL.revokeObjectURL(url)
}

export default function Wallet_Monthly_Transaction_Summary_ExportPDF(
  filterValues: any,
  setDownloadLoading: any
): void {
  const SISPAY_API = String(process.env.REACT_APP_SISPAY_API)
  const session: any = localStorage.getItem('kt-auth-react-v')?.replace(/"/g, '')

  let walletId = filterValues.walletId.trim()
  let type = filterValues.type
  let walletStatus = filterValues.walletStatus
  let walletAccName = filterValues.walletAccName
  let walletAccNo = filterValues.walletAccNo
  let walletCd = filterValues.walletCd
  let dateTimeFrom = filterValues.dateTimeFrom
  let dateTimeTo = filterValues.dateTimeTo

  setDownloadLoading(true)

  axios
    .post(
      `${SISPAY_API}/wallet/transactionsummary/monthly/list`,
      {
        request: {
          action: 'download',
          session: session,
          fromDate: dateTimeFrom,
          toDate: dateTimeTo,
          // page: currentPage + 1,
          //filter
          ...(walletId && {walletId: walletId}),
          ...(type && {type: type}),
          ...(walletStatus && {walletStatus: walletStatus}),
          ...(walletAccName && {walletAccName: walletAccName}),
          ...(walletAccNo && {walletAccNo: walletAccNo}),
          ...(walletCd && {walletCd: walletCd}),
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(function (response) {
      let formData = response.data.result.walletTransactions
      generateFile(formData, dateTimeFrom, dateTimeTo, keyMap)
      setDownloadLoading(false)
    })
    .catch(function (error) {
      setDownloadLoading(false)
    })
}
